/** * @author ❤️❤️❤️ FightFastest 🤎🤎🤎 * @date 🚙 🚒 🛺 8/3/2022 下午 3:29 下午 1:57 🚌🚄🚈🚝 */
<template>
	<div class="knowledge" id="pdfDom">
		<layout :mainTitle="schoolName" secondTitle="必备知识、关键能力与学科素养分析报告" btnName="导出PDF报告" @downloadPDF="downloadPDF" ref="pdfDom">
			<basic-info :info="basicInfo" title="当前班级">
				<template v-if="!isPrint">
					<span class="change-subject" @click="changeSubDialog">切换科目</span>
					<span class="change-subject" @click="pointSubDialog" style="margin-left: 15px">知识点标定</span>
				</template>
			</basic-info>
			<div style="margin-top:30px">
				<div class="name">
					<div class="name-bar"></div>
					<div>学生列表</div>
				</div>
				<div class="filter" v-if="!isPrint">
					<el-input v-model="userName" placeholder="请输入学生姓名" @change="filterStudent"></el-input>
					<el-button type="primary" style="margin-left: 20px">搜 索</el-button>
				</div>
				<el-table style="margin-top: 20px" :data="studentList" border strip highlight-current-row @current-change="handleCurrentRowChange">
					<el-table-column type="index" width="50" align="center"></el-table-column>
					<el-table-column prop="studentName" label="姓名" align="center"> </el-table-column>
					<el-table-column prop="studentNum" label="学号" width="200" align="center"> </el-table-column>
					<el-table-column prop="className" label="班级" align="center"> </el-table-column>
					<el-table-column prop="score" label="得分" align="center"> </el-table-column>
					<el-table-column prop="scoreRate" label="得分率" align="center"> </el-table-column>
					<el-table-column prop="classRank" label="班级排名" align="center"> </el-table-column>
					<el-table-column prop="schoolRank" label="年级排名" align="center"> </el-table-column>
				</el-table>
				<div v-show="!isPrint">
					<div class="ope-pag" v-if="!isFoldAll">
						<el-pagination
							background
							layout="prev, pager, next"
							:total="total"
							:page-size="10"
							@current-change="curPageChaneg"
							@prev-click="curPageChaneg"
							@next-click="curPageChaneg"
						></el-pagination>
						<div class="fold-down" @click="foldAll">
							展开全部
							<i class="iconfont iconjiantou"></i>
						</div>
					</div>
					<div class="fold-up" @click="foldUp" v-else>收起全部 <i class="iconfont iconjiantou-up"></i></div>
				</div>
			</div>
			<div style="margin-top: 50px">
				<div class="name">
					<div class="name-bar"></div>
					<div>知识点分类</div>
				</div>
				<div class="echarts">
					<vue-echarts :options="barOption" class="charts"></vue-echarts>
				</div>
			</div>
		</layout>
		<el-dialog
			width="75%"
			title="切换科目"
			:visible.sync="dialogSubVisible"
			:close-on-click-modal="false"
			:close-on-press-escape="false"
			:show-close="false"
			@close="closeSubDialog"
		>
			<subject v-model="dialogSubVisible" @subConfirm="subConfirm" @basicInfo="getBasicInfo" @mySchoolName="mySchoolName"></subject>
		</el-dialog>
		<el-dialog width="80%" :visible.sync="dialogContactVisible" @close="closeContactDialog" class="point-wrap">
			<contact :knowledgeBasicInfo="knowledgeBasicInfo" v-model="dialogContactVisible" v-if="dialogContactVisible" />
		</el-dialog>
	</div>
</template>

<script>
import cookies from '@/utils/cookie'
import vueEcharts from 'vue-echarts'
import 'echarts/lib/chart/bar'
import 'echarts/lib/component/tooltip'
import 'echarts/lib/component/title'
import 'echarts/lib/component/markArea'
import 'echarts/lib/component/grid'
import 'echarts/lib/component/legend'
import 'echarts/lib/component/axis'

export default {
	name: 'temp',
	components: {
		vueEcharts,
		layout: () => import('../utils/components/report-layout'),
		basicInfo: () => import('../utils/components/basic-info'),
		subject: () => import('./components/subject'),
		contact: () => import('./components/contact')
	},
	data() {
		return {
			dialogSubVisible: true,
			dialogContactVisible: false,
			basicInfo: '',
			barOption: {},
			knowledgeBasicInfo: {},
			studentList: [],
			userName: '',
			studentId: null,
			isFoldAll: false,
			isPrint: false,
			schoolName: '',
			query: this.$route.query,
			page: 1,
			total: 0,
			limit: 10
		}
	},
	created() {
		cookies.set('token', this.query.token)
		this.$screenRation()
	},
	methods: {
		mySchoolName(val) {
			console.log(val)
			this.schoolName = val
		},
		//导出pdf
		downloadPDF() {
			this.isPrint = true
			const _this = this
			setTimeout(function() {
				_this.$print(_this.$refs['pdfDom'])
			}, 1000)
		},
		getBasicInfo(val) {
			this.basicInfo = val
		},
		// 检索学生
		filterStudent() {
			this.queryStudentList()
		},
		// 学生列表
		queryStudentList() {
			const params = {
				...this.knowledgeBasicInfo,
				examId: this.query.examId,
				userName: this.userName,
				page: this.page,
				limit: this.limit
			}
			this.$post('knowledgeSubjectConfig/queryStudentList', params).then(res => {
				this.studentList = res.data || []
				this.total = Number(res.studentNum)
				this.studentId = res.data[0].studentId
				this.queryStudentKnowledgeInfo()
			})
		},
		// 单选
		handleCurrentRowChange(val) {
			this.studentId = val.studentId
			this.queryStudentKnowledgeInfo()
			let dom = document.getElementById('pdfDom')
			dom.scrollTop = dom.scrollHeight
		},
		// 柱状图
		queryStudentKnowledgeInfo() {
			const params = {
				...this.knowledgeBasicInfo,
				examId: this.query.examId,
				studentId: this.studentId
			}
			this.$post('knowledgeSubjectConfig/queryStudentKnowledgeInfo', params).then(res => {
				let xAxisData = [],
					studentQuestionScore = [],
					avgScore = [],
					customizeAvgScore = []
				res.data.forEach(resp => {
					xAxisData.push(resp.knowledgeName)
					studentQuestionScore.push(resp.studentQuestionScore)
					avgScore.push(resp.avgScore)
					customizeAvgScore.push(resp.customizeAvgScore)
				})
				this.operateBarInfo(xAxisData, studentQuestionScore, avgScore, customizeAvgScore)
			})
		},
		operateBarInfo(xAxisData, studentQuestionScore, avgScore, customizeAvgScore) {
			this.barOption = {
				tooltip: {
					trigger: 'axis',
					axisPointer: {
						type: 'shadow'
					},
					formatter: '学生平均分: {c0}<br />班级平均分: {c1}<br />自定义平均分: {c2}'
				},
				legend: {
					data: ['学生平均分', '班级平均分', '自定义平均分'],
					right: 50,
					top: 0,
					textStyle: {
						fontSize: 15,
						color: '#0b0b0b'
					},
					itemWidth: 25,
					itemHeight: 15
				},
				grid: {
					top: '7%',
					right: '5%',
					left: '5%',
					bottom: '8%'
				},
				xAxis: {
					name: '类型',
					type: 'category',
					offset: 2,
					nameRotate: 30,
					data: xAxisData,
					axisTick: {
						show: true
					},
					axisLine: {
						show: true,
						symbol: ['none', 'arrow'],
						symbolSize: [8, 8],
						lineStyle: {
							color: '#006a60'
						}
					},
					axisLabel: {
						margin: 10,
						color: '#006a60',
						rotate: 20,
						textStyle: {
							fontSize: 14
						}
					}
				},
				yAxis: {
					show: true,
					name: '分值',
					axisLine: {
						show: true,
						symbol: ['none', 'arrow'],
						symbolSize: [8, 8],
						lineStyle: {
							color: '#006a60'
						}
					},
					splitLine: {
						lineStyle: {
							type: 'dashed'
						}
					}
				},
				series: [
					{
						name: '学生平均分',
						type: 'bar',
						data: studentQuestionScore,
						barWidth: '20px',
						colorBy: 'data',
						itemStyle: {
							normal: {
								color: '#009688',
								barBorderRadius: [30, 30, 30, 30],
								shadowColor: '#006a60',
								shadowBlur: 4
							}
						},
						label: {
							normal: {
								show: true,
								lineHeight: 30,
								borderRadius: 100,
								position: ['4', '-30'],
								distance: 1
							}
						}
					},
					{
						name: '班级平均分',
						type: 'bar',
						data: avgScore,
						barWidth: '20px',
						colorBy: 'data',
						itemStyle: {
							color: '#ef0745',
							barBorderRadius: [30, 30, 30, 30],
							shadowColor: '#ef0745',
							shadowBlur: 4
						},
						label: {
							normal: {
								show: true,
								lineHeight: 30,
								borderRadius: 100,
								position: ['4', '-30'],
								distance: 1
							}
						}
					},
					{
						name: '自定义平均分',
						type: 'bar',
						data: customizeAvgScore,
						barWidth: '20px',
						colorBy: 'data',
						itemStyle: {
							color: '#efd007',
							barBorderRadius: [30, 30, 30, 30],
							shadowColor: '#efd007',
							shadowBlur: 4
						},
						label: {
							normal: {
								show: true,
								lineHeight: 30,
								borderRadius: 100,
								position: ['4', '-30'],
								distance: 1
							}
						}
					}
				]
			}
		},
		closeSubDialog() {
			this.dialogSubVisible = false
		},
		closeContactDialog() {
			this.dialogContactVisible = false
		},
		changeSubDialog() {
			this.dialogSubVisible = true
		},
		pointSubDialog() {
			this.dialogContactVisible = true
		},
		// 科目选择 确定
		subConfirm(val) {
			this.knowledgeBasicInfo = val
			this.queryStudentList()
		},
		// 分页
		curPageChaneg(val) {
			this.page = val
			this.queryStudentList()
		},
		//展开
		foldAll() {
			this.isFoldAll = true
			this.limit = this.total
			this.page = 1
			this.queryStudentList()
		},
		// 收起
		foldUp() {
			this.isFoldAll = false
			this.limit = 10
			this.page = 1
			this.queryStudentList()
		}
	}
}
</script>

<style scoped lang="less">
@import '../utils/style';
.knowledge {
	width: 100%;
	height: 100%;
	//background: #ebebeb;
	overflow: auto;
	.change-subject {
		display: inline-block;
		margin-left: 30px;
		color: #009688;
		font-weight: bolder;
		&:hover {
			cursor: pointer;
		}
	}
	.filter {
		display: flex;
		justify-content: flex-start;
		width: 500px;
		margin: 20px 10px 20px 0;
	}
	.echarts {
		width: 100%;
		height: 500px;
		margin-top: 25px;
		.charts {
			width: 100%;
			height: 100%;
		}
	}
	.name {
		font-size: 20px;
		display: flex;
		align-items: center;
		font-weight: bolder;
		.name-bar {
			display: inline-block;
			width: 3px;
			height: 20px;
			background: #009688;
			margin-right: 8px;
		}
	}
	.ope-pag {
		display: flex;
		justify-content: space-between;
		margin-top: 15px;
		.fold-down {
			font-size: 15px;
			border-radius: 15px;
			border: 1px solid #009688;
			display: flex;
			align-items: center;
			padding: 0 10px;
			&:hover {
				cursor: pointer;
			}
			.iconjiantou {
				font-size: 17px;
				color: #009688;
				margin-left: 3px;
			}
		}
	}
	.fold-up {
		height: 60px;
		border: 1px solid #ebebeb;
		display: flex;
		justify-content: center;
		align-items: center;
		font-size: 17px;
		&:hover {
			cursor: pointer;
		}
		.iconfont {
			font-size: 17px;
			margin-left: 6px;
			color: #009688;
		}
	}
	.point-wrap {
		/deep/.el-dialog__header {
			padding-top: 5px;
		}
		/deep/.el-dialog__body {
			padding: 5px 20px 15px;
		}
	}
}
</style>
